export const state = {
	open: false,
};

export const getters = {
	isOpen(state) {
		return state.open;
	},
};

export const mutations = {
	SET_OPEN_MENU(state, newValue) {
		state.open = newValue;
	},
};

export const actions = {
	CambarEstadoMenu({ commit, getters }) {
		commit('SET_OPEN_MENU', !getters.isOpen);
	},
};
